{
  "generatedFrom": "git-history",
  "sharedExcludedCount": 257,
  "routes": {
    "/about": "2026-10-15",
    "/adjustable-gastric-banding": "2026-08-08",
    "/adjustable_gastric_banding": "2026-07-22",
    "/admin": "2026-09-21",
    "/app-privacy-policy": "2026-09-29",
    "/appointments": "2026-10-02",
    "/ask-dr-fitzer": "2026-07-22",
    "/contact-us/ask-dr-fitzer": "2026-07-22",
    "/contact-us": "2026-07-22",
    "/contact-us/map-and-directions": "2026-07-22",
    "/contact": "2026-10-05",
    "/dev/og-preview": "2026-09-12",
    "/dr-fitzer-dissects-the-news": "2026-09-13",
    "/dr-fitzer-img": "2026-09-29",
    "/es/antes-y-despues": "2026-10-21",
    "/es/balon-gastrico": "2026-10-02",
    "/es/banda-gastrica": "2026-10-04",
    "/es/bypass-gastrico": "2026-10-04",
    "/es/bypass-o-manga-gastrica": "2026-10-04",
    "/es/cirugia-bariatrica-de-pago-directo": "2026-10-02",
    "/es/cirugia-bariatrica-virginia": "2026-10-05",
    "/es/cirugia-de-revision": "2026-10-05",
    "/es/cirugia-de-revision/banda-gastrica": "2026-10-08",
    "/es/cirugia-de-revision/bypass-gastrico": "2026-10-08",
    "/es/cirugia-de-revision/manga-gastrica": "2026-10-08",
    "/es/cirugia-de-revision/tore": "2026-10-08",
    "/es/cobertura-de-seguro": "2026-10-05",
    "/es/contacto": "2026-10-02",
    "/es/el-doctor-analiza-las-noticias": "2026-09-13",
    "/es/gastroplastia-endoscopica-en-manga": "2026-10-02",
    "/es": "2026-10-02",
    "/es/manga-gastrica": "2026-10-05",
    "/es/medicamentos-orales-para-bajar-de-peso": "2026-10-18",
    "/es/medicamentos-para-bajar-de-peso": "2026-10-02",
    "/es/obesidad-y-diabetes": "2026-10-02",
    "/es/perdida-de-peso-con-medicamentos": "2026-10-18",
    "/es/precios-y-financiamiento": "2026-10-05",
    "/es/preguntas-frecuentes": "2026-09-30",
    "/es/quien-califica-para-medicamentos": "2026-10-05",
    "/es/recuperacion-de-peso-despues-de-cirugia-bariatrica": "2026-10-04",
    "/es/reparacion-de-hernia-hiatal": "2026-10-22",
    "/es/requisitos-para-cirugia": "2026-10-23",
    "/es/seguro-para-cirugia-bariatrica": "2026-09-03",
    "/es/seguro/carolina-del-norte": "2026-10-02",
    "/es/seguro/medicaid-y-cardinal-care": "2026-10-05",
    "/es/seguro/medicare-tricare-y-fehb": "2026-10-05",
    "/es/seguro/pago-propio-y-negaciones": "2026-10-05",
    "/es/seguro/plan-comercial-y-marketplace": "2026-10-05",
    "/es/semaglutida": "2026-10-18",
    "/es/servicios": "2026-10-04",
    "/es/sobre-el-doctor": "2026-10-02",
    "/es/tirzepatida": "2026-10-18",
    "/favicon": "2026-07-22",
    "/financing-with-prosper-healthcare-lending": "2026-07-22",
    "/gastric-bypass": "2026-08-08",
    "/hiatal": "2026-10-15",
    "/": "2026-10-04",
    "/intragastric-balloon-2": "2026-07-22",
    "/lets-get-started": "2026-07-22",
    "/lets-get-started/register-for-a-seminar": "2026-07-22",
    "/lets-get-started/schedule-a-consultation-2": "2026-09-29",
    "/lets-get-started/schedule-an-office-visit": "2026-07-22",
    "/life-after-surgery/all-group-calendar": "2026-07-22",
    "/life-after-surgery/exercise": "2026-07-22",
    "/life-after-surgery": "2026-07-22",
    "/life-after-surgery/nutrition": "2026-07-22",
    "/life-after-surgery/support-group-calendar": "2026-07-22",
    "/medical-weight-loss": "2026-10-18",
    "/medical-weight-loss/insurance/cash-pay-denials": "2026-08-13",
    "/medical-weight-loss/insurance/commercial-marketplace": "2026-08-13",
    "/medical-weight-loss/insurance": "2026-08-18",
    "/medical-weight-loss/insurance/medicaid-cova": "2026-08-13",
    "/medical-weight-loss/insurance/medicare-tricare-fehb": "2026-08-13",
    "/medical-weight-loss/insurance/nc": "2026-08-18",
    "/medical-weight-loss/medications": "2026-10-02",
    "/medical-weight-loss/oral-medications": "2026-10-18",
    "/medical-weight-loss/other-medications": "2026-08-12",
    "/medical-weight-loss/qualifications": "2026-09-29",
    "/medical-weight-loss/semaglutide": "2026-10-18",
    "/medical-weight-loss/tirzepatide": "2026-10-18",
    "/our-comprehensive-program/about-dr-fitzer": "2026-07-22",
    "/our-comprehensive-program": "2026-07-22",
    "/our-comprehensive-program/meet-our-staff": "2026-07-22",
    "/our-comprehensive-program/meet-our-team": "2026-07-22",
    "/our-program": "2026-10-02",
    "/our-success-stories/[index]": "2026-07-22",
    "/our-success-stories": "2026-07-22",
    "/our-success-stories/share-your-story": "2026-07-22",
    "/our-ten-year-weight-loss-data": "2026-07-22",
    "/patient-portal": "2026-07-22",
    "/patient-resources/eforms": "2026-07-22",
    "/patient-resources": "2026-07-22",
    "/patient-resources/newsletter": "2026-07-22",
    "/patient-resources/patient-portal": "2026-07-22",
    "/patient-resources/video-suite": "2026-07-22",
    "/preventing-weight-regain-after-discontinuation-of-injectable-weight-loss-medicines-part-one": "2026-07-25",
    "/preventing-weight-regain-after-discontinuation-of-injectable-weight-loss-medicines-part-three": "2026-07-25",
    "/preventing-weight-regain-after-discontinuation-of-injectable-weight-loss-medicines-part-two/annot": "2026-07-25",
    "/preventing-weight-regain-after-discontinuation-of-injectable-weight-loss-medicines-part-two": "2026-07-25",
    "/resources/faq": "2026-10-02",
    "/resources/forms": "2026-10-02",
    "/resources": "2026-10-02",
    "/resources/instructions": "2026-10-02",
    "/resources/insurance-coverage": "2026-08-13",
    "/resources/managing-weight-regain-after-bariatric-surgery": "2026-10-04",
    "/resources/nutrition": "2026-10-02",
    "/resources/obesity-and-diabetes": "2026-10-05",
    "/resources/prosper": "2026-10-05",
    "/resources/qualifications": "2026-10-23",
    "/resources/qualifications/print": "2026-10-23",
    "/resources/suggestion": "2026-10-02",
    "/resources/support": "2026-10-06",
    "/results": "2026-10-21",
    "/results/share-cards": "2026-10-21",
    "/results/share-your-story": "2026-10-02",
    "/results/story-preview": "2026-10-21",
    "/revisions-surgery": "2026-08-08",
    "/schedule-an-office-visit": "2026-07-22",
    "/schedule": "2026-07-25",
    "/search": "2026-10-02",
    "/self-pay-bariatric-surgery": "2026-10-02",
    "/semaglutide-versus-weight-loss-surgery-outcomes/bypass": "2026-09-29",
    "/semaglutide-versus-weight-loss-surgery-outcomes": "2026-07-25",
    "/semaglutide-versus-weight-loss-surgery-outcomes/sleeve": "2026-09-29",
    "/services/balloon": "2026-10-02",
    "/services/band": "2026-10-04",
    "/services/bypass-vs-sleeve": "2026-10-15",
    "/services/bypass": "2026-10-15",
    "/services/esg": "2026-10-02",
    "/services/hiatal-hernia-surgery": "2026-10-22",
    "/services": "2026-10-15",
    "/services/medication": "2026-07-30",
    "/services/medications": "2026-08-28",
    "/services/revisions/gastric-bypass": "2026-10-15",
    "/services/revisions": "2026-10-15",
    "/services/revisions/lap-band": "2026-10-15",
    "/services/revisions/sleeve": "2026-10-15",
    "/services/revisions/tore": "2026-10-15",
    "/services/sleeve": "2026-10-15",
    "/sitemap": "2026-07-22",
    "/sleeve-gastrectomy-surgery-works": "2026-09-29",
    "/sleeve-revision": "2026-09-29",
    "/social-cards": "2026-09-21",
    "/susanna-carter-pic": "2026-09-29",
    "/team": "2026-10-17",
    "/telehealth": "2026-07-27",
    "/understanding-obesity-2": "2026-10-02",
    "/understanding-obesity/bariatric-surgery-and-diabetes": "2026-07-22",
    "/understanding-obesity/bariatric-surgery-and-diabetes/patient-morgan-before-and-after": "2026-07-22",
    "/understanding-obesity": "2026-07-22",
    "/understanding-obesity/obesity-related-medical-problems": "2026-07-22",
    "/understanding-obesity/qualifications-for-surgery/criteria-for-bariatric-surgery-up-2": "2026-07-25",
    "/understanding-obesity/qualifications-for-surgery": "2026-07-25",
    "/weight-loss-journey-before-after": "2026-07-22",
    "/weight-loss-options/adjustable-gastric-banding": "2026-07-22",
    "/weight-loss-options/bariatric-surgery-patient-outcome": "2026-07-22",
    "/weight-loss-options/endoscopic-sleeve-gastrectomy-and-revisions": "2026-07-22",
    "/weight-loss-options/intragastric-balloon": "2026-07-22",
    "/weight-loss-options/medical-management": "2026-07-30",
    "/weight-loss-options/revision-surgery-2": "2026-07-22",
    "/weight-loss-options/revisions-surgery": "2026-07-22",
    "/weight-loss-options/sleeve-gastrectomy": "2026-07-22",
    "/weight-loss-surgery-options/adjustable-gastric-banding": "2026-07-22",
    "/weight-loss-surgery-options/gastric-bypass": "2026-07-22",
    "/weight-loss-surgery-options": "2026-07-22",
    "/weight-loss-surgery-options/revision-surgery": "2026-07-22",
    "/weight-loss-surgery-options/sleeve-gastrectomy": "2026-07-22",
    "/weight-lost-surgery-option": "2026-07-22",
    "/weight-regain-after-stopping-injectable-medication-whats-the-reality": "2026-07-22",
    "/weight-regain-after-stopping-injectable-medication-whats-the-reality/regain-image": "2026-07-22",
    "/why-are-gastric-bypass-patients-at-risk-for-alcoholism": "2026-07-22"
  },
  "libs": {
    "stories": "2026-10-21",
    "esStories": "2026-10-02"
  },
  "posts": {
    "/dr-fitzer-dissects-the-news/eye-problems-and-glp-1-medications": "2026-08-11",
    "/dr-fitzer-dissects-the-news/glp-1-management-stat": "2026-10-02",
    "/dr-fitzer-dissects-the-news/glp-1s-improve-survival-for-women-with-breast-cancer": "2026-10-02",
    "/dr-fitzer-dissects-the-news/magnetic-weight-loss-surgery-a-primer-on-magdi": "2026-10-24",
    "/dr-fitzer-dissects-the-news/our-ten-year-weight-loss-data": "2026-10-02",
    "/dr-fitzer-dissects-the-news/preventing-weight-regain-after-discontinuation-of-injectable-weight-loss-medicines-part-one": "2026-09-13",
    "/dr-fitzer-dissects-the-news/preventing-weight-regain-after-discontinuation-of-injectable-weight-loss-medicines-part-three": "2026-09-13",
    "/dr-fitzer-dissects-the-news/preventing-weight-regain-after-discontinuation-of-injectable-weight-loss-medicines-part-two": "2026-09-13",
    "/dr-fitzer-dissects-the-news/semaglutide-versus-weight-loss-surgery-outcomes": "2026-10-02",
    "/dr-fitzer-dissects-the-news/weight-regain-after-stopping-injectable-medication-whats-the-reality": "2026-10-04",
    "/dr-fitzer-dissects-the-news/why-are-gastric-bypass-patients-at-risk-for-alcoholism": "2026-08-23"
  },
  "esPosts": {
    "/es/el-doctor-analiza-las-noticias/problemas-de-la-vista-y-medicamentos-glp-1": "2026-09-14",
    "/es/el-doctor-analiza-las-noticias/manejo-de-glp-1-al-instante": "2026-10-02",
    "/es/el-doctor-analiza-las-noticias/los-glp-1-mejoran-la-supervivencia-en-cancer-de-mama": "2026-10-02",
    "/es/el-doctor-analiza-las-noticias/cirugia-magnetica-para-bajar-de-peso-guia-de-magdi": "2026-10-24",
    "/es/el-doctor-analiza-las-noticias/nuestros-datos-de-perdida-de-peso-a-diez-anos": "2026-10-02",
    "/es/el-doctor-analiza-las-noticias/recuperacion-de-peso-tras-wegovy-zepbound-parte-1": "2026-10-02",
    "/es/el-doctor-analiza-las-noticias/recuperacion-de-peso-tras-wegovy-zepbound-parte-3": "2026-10-02",
    "/es/el-doctor-analiza-las-noticias/recuperacion-de-peso-tras-wegovy-zepbound-parte-2": "2026-10-02",
    "/es/el-doctor-analiza-las-noticias/semaglutida-contra-cirugia-resultados": "2026-10-02",
    "/es/el-doctor-analiza-las-noticias/recuperacion-de-peso-tras-dejar-inyectables-la-realidad": "2026-10-04",
    "/es/el-doctor-analiza-las-noticias/riesgo-de-alcoholismo-en-pacientes-de-bypass-gastrico": "2026-10-02"
  }
}
